export default "<p>board-moderator works!</p>\n"